import { createFileRoute } from '@tanstack/react-router'
import {
  FRAUD_ANALYSIS_DEFAULT_CLIENT_TYPE,
  fraudAnalysisClientTypeSchema,
  FraudAnalysisModelsPage,
  fraudScoreDatasetHealthQueryOptions,
  fraudScoreLabelCategoriesQueryOptions,
  fraudScoreLabelDefinitionsQueryOptions,
  fraudScoreModelsQueryOptions,
} from 'features/fraudAnalysis'
import { z } from 'zod/v4'

const fraudAnalysisModelsSearchSchema = z.object({
  clientType: fraudAnalysisClientTypeSchema
    .default(FRAUD_ANALYSIS_DEFAULT_CLIENT_TYPE)
    .catch(FRAUD_ANALYSIS_DEFAULT_CLIENT_TYPE),
})

export type FraudAnalysisModelsSearchParams = z.infer<typeof fraudAnalysisModelsSearchSchema>

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/')({
  validateSearch: fraudAnalysisModelsSearchSchema,
  component: FraudAnalysisModelsPage,
  loaderDeps: ({ search: { clientType } }) => ({ clientType }),
  loader: ({
    context: { queryClient, buildRequest, fraudScoreEntitlement },
    params: { subscriptionId },
    deps: { clientType },
  }) => {
    if (fraudScoreEntitlement === 'disabled') {
      return
    }

    void queryClient.prefetchQuery(fraudScoreLabelCategoriesQueryOptions(buildRequest))
    void queryClient.prefetchQuery(fraudScoreLabelDefinitionsQueryOptions(buildRequest, subscriptionId))
    void queryClient.prefetchQuery(fraudScoreDatasetHealthQueryOptions(buildRequest, subscriptionId, { clientType }))
    void queryClient.prefetchInfiniteQuery(fraudScoreModelsQueryOptions(buildRequest, subscriptionId, { clientType }))
  },
})
